const loop = ['中国美食', '东方风土', '人的愿望', 'NOMOISM 创作', 'IP 角色', '进入年轻人的生活'];

export default function WhyNomoism() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="reveal lg:col-span-4">
            <div className="mb-6 flex items-center gap-3">
              <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
                Section 07
              </span>
              <span className="h-px w-8 bg-primary-300"></span>
              <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
                Why NOMOISM
              </span>
            </div>
            <h2 className="font-heading text-3xl leading-snug text-foreground-950 md:text-4xl">
              WHY
              <br />
              NOMOISM?
            </h2>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-foreground-600 md:text-base">
              我们真正想占据的，不是一个品类，而是一种创作方法。
            </p>
          </div>

          <div className="reveal lg:col-span-8" style={{ transitionDelay: '160ms' }}>
            <div className="rounded-lg border border-accent-200/70 bg-accent-50/70 p-7 md:p-10">
              <p className="font-heading text-xl leading-relaxed text-foreground-900 md:text-2xl md:leading-[1.7]">
                我们相信，文化不应该只存在于博物馆里。
                <br />
                它可以是一条小鱼，可以是一碗面，可以是一句祝福，可以是一个陪你生活的角色。
              </p>

              <div className="my-7 h-px w-full bg-accent-200"></div>

              <div className="space-y-5 text-sm leading-relaxed text-foreground-700 md:text-base">
                <p>
                  NOMOISM 从中国美食出发，从东方风土寻找灵感，从当代人的愿望中寻找情绪。
                </p>
                <p>
                  我们想做的，是让传统文化重新变得好玩，让中国故事拥有新的角色，
                  让东方文化成为当代生活的一部分。
                </p>
              </div>

              <p className="mt-8 font-heading text-lg text-primary-700 md:text-xl">
                一味 × 一境 × 一愿，创造属于当代人的东方潮玩。
              </p>
            </div>
          </div>
        </div>

        <div className="reveal mt-14 rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-9">
          <p className="mb-6 text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
            The NOMOISM Loop · 品牌闭环
          </p>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-2">
            {loop.map((node, index) => (
              <div key={node} className="flex items-center gap-2 md:flex-1">
                <span className="flex-1 rounded-md bg-background-50 px-4 py-3 text-center text-xs text-foreground-800 md:text-sm">
                  {node}
                </span>
                {index < loop.length - 1 && (
                  <span className="text-foreground-300" aria-hidden="true">
                    <i className="ri-arrow-right-line hidden md:block"></i>
                    <i className="ri-arrow-down-line md:hidden"></i>
                  </span>
                )}
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-primary-600">
            一个地方可以产生一个 IP，一道美食可以产生一个故事，一种愿望可以形成一个角色。
          </p>
        </div>
      </div>
    </section>
  );
}